// libs
import React from 'react';
import isEmpty from 'lodash/isEmpty';

// components
import { OverlaySheetContext, SHEET_TRANSITION } from 'shared/components/OverlaySheet';
import ValidityText from 'shared/layouts/Coupons/CouponsExpiry/CouponValdity/CouponValidity';

// context
import { useLoaderContext } from 'shared/components/LoaderProvider/context';
import { useDomainConfig } from 'shared/domainConfig/context/context';

// svgs
import CloseIcon from '@nykaa/ui-components/Icons/close';

// styles
import {
  Header,
  Title,
  Subtitle,
  InfoContainer,
  IconContainer,
  Image,
  CouponInfoDesktop,
  TermsAndContitionsDesktop,
  TACHeading,
  TACList,
  TACItem,
  BottomContainer,
  ActionContainerPDP,
  CopyButtonPDP,
  ActionButtonPDP,
  OverlaySheetDesktop,
  IconContainerDesktop as CloseButton,
  FixedContent,
  CouponCodeContainer,
  CouponCode,
  InfoContainerWrapper,
} from 'shared/layouts/Coupons/ViewDetailsNudge/styles';

// constants
import { TEXTS } from 'shared/layouts/Coupons/constants';
import { LOGO_TYPE } from 'shared/constants';

// types
import { CouponDetails } from 'shared/layouts/Coupons/types';
import Logo from 'shared/components/Logo';

// defs
interface ViewDetailsNudgeDesktopProps {
  onHide: VoidFunction;
  couponDetails: CouponDetails;
  onCopyClicked: (couponCode: string) => void;
  className?: string;
  ViewDetailsNudgeDesktopProps?: string;
  sheetTransition?: SHEET_TRANSITION;
}

function ViewDetailsNudgeDesktop({
  onHide,
  couponDetails,
  onCopyClicked,
  className = '',
  sheetTransition = SHEET_TRANSITION.RIGHT,
}: ViewDetailsNudgeDesktopProps) {
  const { showLoader, hideLoader } = useLoaderContext();

  const {
    COLOR: { COUPON_CODE_BACKGROUND },
  } = useDomainConfig();

  if (isEmpty(couponDetails)) {
    showLoader({ right: '14%', left: 'none' });
    return null;
  } else hideLoader();

  const { couponCode, imageUrl, title, subtitle, tnc, expiryEpoch = 0 } = couponDetails;

  return (
    <OverlaySheetDesktop
      onHide={onHide}
      transitionFrom={sheetTransition}
      className={className}
      navKey={'coupon-dweb'}
    >
      <OverlaySheetContext.Consumer>
        {({ doHide }) => (
          <FixedContent>
            <Header>
              <CloseButton onClick={doHide}>
                <CloseIcon />
              </CloseButton>
            </Header>
            <InfoContainerWrapper>
              <InfoContainer showBottomBorder className="infoContainer">
                <IconContainer>
                  {imageUrl === '' || imageUrl === null ? (
                    <Logo type={LOGO_TYPE.COUPONS} />
                  ) : (
                    <Image src={imageUrl} width={66} height={66} alt="coupon logo" />
                  )}
                </IconContainer>
                <CouponInfoDesktop>
                  <Title>{title}</Title>
                  <Subtitle>{subtitle}</Subtitle>
                  {expiryEpoch > 0 && <ValidityText expiryEpoch={expiryEpoch} />}
                </CouponInfoDesktop>
              </InfoContainer>
              {tnc && tnc.length > 0 && (
                <TermsAndContitionsDesktop>
                  <TACHeading>{TEXTS.TERMS_AND_CONDITIONS}</TACHeading>
                  <TACList className="termsConditionsList">
                    {tnc && tnc.map((item, i) => <TACItem key={i}>{item}</TACItem>)}
                  </TACList>
                </TermsAndContitionsDesktop>
              )}
            </InfoContainerWrapper>
            <BottomContainer showTopBorder={false} isDesktop={true}>
              <CouponCodeContainer
                isApplied={false}
                className="couponCodeContainer"
                bgColor={COUPON_CODE_BACKGROUND}
              >
                <CouponCode className="couponCode">{couponCode}</CouponCode>
              </CouponCodeContainer>
              <ActionContainerPDP className="actionContainer">
                <ActionButtonPDP onClick={() => onHide()}>{TEXTS.DISMISS}</ActionButtonPDP>
                <CopyButtonPDP onClick={() => onCopyClicked(couponCode || '')} disabled={false}>
                  {TEXTS.COPY_CODE}
                </CopyButtonPDP>
              </ActionContainerPDP>
            </BottomContainer>
          </FixedContent>
        )}
      </OverlaySheetContext.Consumer>
    </OverlaySheetDesktop>
  );
}

export default ViewDetailsNudgeDesktop;
